<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout wrap>
      <v-flex md12>
        <div>
          <v-tabs
            v-model="active"
            color="primary"
            dark
            slider-color="secondary">

            <v-tab
              v-for="header in getHeaders()"
              :key="header.id"
              ripple
              class="justify-center"
              @click="refreshTabData ()">
              {{ header.trans }}
            </v-tab>

            <v-tab-item>
              <application-report
                ref="applicationsReport"
                :refresh="refresh"
                :selection="selection"/>
            </v-tab-item>
            <v-tab-item>
              <factorings-report ref="factoringsReport"/>
            </v-tab-item>
            
            <v-tab-item>
              <TransfersReport ref="transfersReport"/>
            </v-tab-item>
            <!--  
            <v-tab-item>
              <v-flex
                xs12
                sm6
                md4>
                <v-btn
                  :disabled="summaryLoader"
                  :loading="summaryLoader"
                  class=""
                  color="primary"
                  @click="getSummaryReport">{{ 'Get excel report' | translate }}</v-btn>
              </v-flex>
            </v-tab-item>
            -->
            <v-tab-item>
              <repayments-report ref="repaymentsReport"/>
            </v-tab-item>
          </v-tabs>

          <!--<div class="text-xs-center mt-3">
				<v-btn @click="next">next tab</v-btn>
			</div>-->
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import Pagination from './controllers/Pagination.vue';
import ApplicationReport from './reports/application/ApplicationReport';
import FactoringsReport from './reports/factorings/FactoringsReport';
import TransfersReport from './reports/transfers/TransfersReport';
import RepaymentsReport from './reports/repayments/RepaymentsReport';
  export default {
    components: {Pagination, ApplicationReport, FactoringsReport, TransfersReport, RepaymentsReport},
    props: ['selection'],
    data: () => ({
      factoringsCreatedToDateLabel: 'duh',

      active: null,
      // items: ['None', 'Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'This month', 'Last month', 'Year to day', 'Last year', 'Custom'],

      refresh: false,

      //data
      notificationReportData: [],

      summaryLoader: false
    }),
    computed: {
      ...mapState({
        UserInfo: state => state.userInfo,
        changingSelectedCompany: state => state.changingSelectedCompany
      })
    },
    watch: {
      UserInfo ()
      {
        let self = this;

        self.refresh = true;
        self.refreshTabData ();
      }
    },
    mounted() {
    },
    updated()
    {
      let self = this;
      if (self.refresh)
      {
        switch (self.active)
        {
          case 0:
            self.$refs.applicationsReport.refreshApplicationReportData ();
            break;
          case 1:
            self.$refs.factoringsReport.refreshFactoringsReportData ();
            break;
          case 2:
            self.$refs.transfersReport.refreshTransfersReportData ();
            break;
          case 4:
            self.$refs.repaymentsReport.refreshRepaymentsReportData ();
            break;
        }

        self.refresh = false;
      }
    },
    methods: {
      setApplicationSelection() {
        this.applicationSelection = this.selection;
      },
      getHeaders() {
        let self = this;
        let result = [
          {id: 0, trans: self.$t('krita.reports.applications')},
          {id: 1, trans: self.$t('krita.reports.factorings.tabheader')},
          {id: 2, trans: self.$t('krita.reports.transfers.tabheader')},
          {id: 3, trans: self.$t('krita.reports.summaryreport.tabheader')},
          {id: 4, trans: self.$t('krita.reports.repayments.tabheader')},
          // self.$t('krita.reports.notifications.tabheader')
        ];

        return result;
      },

      next() {
        const active = parseInt(this.active)
        this.active = (active < 2 ? active + 1 : 0)
      },

      //refreshData

      refreshTabData() {
        let self = this;

        self.refresh = true;
      },
      getSummaryReport ()
      {
        let self = this;
        self.summaryLoader = true;

        self.$store.dispatch('summary/getSummaryReport').then(response =>
        {
          let newWindow = window.open(response.Url, '_blank');
          self.summaryLoader = false;
        }, () =>
        {
          //  error
          self.$store.commit('notification/showNotificationInternal', {type:'error', msg: 'krita.notification.error.getExcelSummaryReport'});
          self.summaryLoader = false;
        })
      },
    },
}
</script>

<style>
  .v-date-picker-table .v-btn .v-btn__content{
    color: black;
    margin: -5px;
  }

  .v-date-picker-header .v-btn .v-btn__content{
    color: black;
  }

  .v-date-picker-table .v-btn{
    color: black;
    padding: 0px;
  }

  .v-btn.v-btn--outline {
    border: 1px solid #3357A0;
    background: transparent !important;
    box-shadow: none;
    padding: 0px;
  }

  .v-date-picker-table .v-btn.v-btn--icon{
    width: 30px;
    height: 30px;
  }

  .v-date-picker-table .v-btn:before{
    border-radius: inherit;
    color: inherit;
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    opacity: 0.12;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
  }

  .v-date-picker-table .v-btn--floating {
    border-radius: 50%;
    min-width: 0;
  }
  .active {
    color: red;
  }

</style>
